@if (title()) {
  <div class="settings-group-header">
    <h3>{{ title() }}</h3>
    @if (scope()) {
      <app-upgrade-badge [scope]="scope()" [location]="location()"></app-upgrade-badge>
    }
    @if (comingSoon()) {
      <app-badge color="orange" icon="/assets/icons/16/clock-filled.svg">Soon</app-badge>
    }
    @if (beta()) {
      <app-badge color="orange">Beta</app-badge>
    }
  </div>
}

<div class="settings-group" [class.no-padding]="noContentPadding()" [class.small]="small()">
  <ng-content></ng-content>
</div>
